import moment from 'moment';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { SPUserContextProvider } from './contexts/SPUserContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppRouter from './navigation/AppRouter';
import store from './redux/store';
import './services/firebase/firebase';
import { InternationalizationProvider } from './services/i18n';

import './styles/index.scss';
import 'moment/locale/nb';
import SPLogoIcon from './resources/images/SP_logo_icon.svg';
import SPLogoName from './resources/images/SP_logo_text.svg';
import TuttiLogoName from './resources/images/Tutti_color_text.svg';
import TuttiLogoIcon from './resources/images/Tutti_color_logo.svg';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { useEffect } from 'react';
import { LicenseInfo } from '@mui/x-license';
import LuxonProvider from './util/luxonProvider';
// @ts-ignore
library.add(fas, far);
moment.locale('nb');

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        },
    },
});

function useInitializeMuiX() {
    useEffect(() => {
        if (window.location.origin.includes('localhost')) {
            return;
        }
        LicenseInfo.setLicenseKey(process.env.MUIX || '');
    }, []);
}

function App() {
    useInitializeMuiX();
    return (
        <React.StrictMode>
            <Provider store={store}>
                <QueryClientProvider client={queryClient}>
                    <InternationalizationProvider>
                        <LuxonProvider>
                            <SPUserContextProvider>
                                <AppRouter />
                            </SPUserContextProvider>
                        </LuxonProvider>
                    </InternationalizationProvider>
                </QueryClientProvider>
            </Provider>
        </React.StrictMode>
    );
}

ReactDOM.render(<App />, document.getElementById('root'));

export { SPLogoName, SPLogoIcon, TuttiLogoName, TuttiLogoIcon };
